import { Routes, Route, Navigate } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { Login } from "./pages/Login";
import { Home } from "./pages/Home";
import ColdEmail from "./pages/ColdEmail";
import FollowUps from "./pages/FollowUps";
import { Replies } from "./pages/Replies";
import { Bookings } from "./pages/Bookings";
import { Audits } from "./pages/Audits";
import { Admin } from "./pages/Admin";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<AppShell />}>
        <Route path="/" element={<Home />} />
        <Route path="/cold" element={<ColdEmail />} />
        <Route path="/followups" element={<FollowUps />} />
        <Route path="/replies" element={<Replies />} />
        <Route path="/bookings" element={<Bookings />} />
        <Route path="/audits" element={<Audits />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
